import { FC } from 'react';
import { Container, Row } from 'react-grid-system';
import Spacing from '../atoms/Spacing';
import LoadingSpinner from './LoadingSpinner';

interface ILoader {
  color: string;
}

const Loader: FC<ILoader> = ({ color }) => (
  <>
    <Spacing spacing={1} />
    <Container>
      <Row justify="center">
        <LoadingSpinner color={color} />
      </Row>
    </Container>
    <Spacing spacing={1} />
  </>
);

export default Loader;
